import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack } from "@mui/material";
import React, { FC } from "react";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { JobInfoItem } from "@/features/job/components/job-detail/JobInfoItem";
import { JobWorkingTimeItemDetail } from "@/features/job/components/job-detail/JobWorkingTimeItemDetail";

type TJobWorkingConditionDetailProps = {
  defaultValues?: Partial<TJobForm>;
  isDraft?: boolean;
};

export const JobWorkingConditionDetail: FC<TJobWorkingConditionDetailProps> = ({ defaultValues, isDraft }) => {
  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="勤務条件" />} padding="24px" showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <JobInfoItem label="勤務場所" value={defaultValues?.workplace} required={!isDraft} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="勤務地（詳細）" value={defaultValues?.workplaceDetail} />
          </Grid>
          <Grid item xs={12}>
            {defaultValues?.jobWorkingTimes?.map((workingTime, index) => (
              <JobWorkingTimeItemDetail title={`労働時間${index + 1}`} workingTime={workingTime} />
            ))}
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="休日（定例日）" value={defaultValues?.regularHolidays} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="休日（非定例日）" value={defaultValues?.irregularHolidays} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem
              label="年間合計休日日数"
              value={
                defaultValues?.totalAnnualHolidays !== null && defaultValues?.totalAnnualHolidays !== undefined
                  ? `${defaultValues.totalAnnualHolidays?.toString()}日`
                  : ""
              }
              isShowDivider={false}
            />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
